export const LANGUAGES = {
  es: { code: 'es', name: 'Spanish', nativeName: 'Español', locale: 'es-AR' },
  en: { code: 'en', name: 'English', nativeName: 'English', locale: 'en-US' },
} as const;

export type LanguageCode = keyof typeof LANGUAGES;

export const LANGUAGE_CODES = Object.keys(LANGUAGES) as LanguageCode[];

export const DEFAULT_LANGUAGE_CODE: LanguageCode = 'en';
